import { prepareValues, type ChangeRecord, type ChangeHistoryAction } from './utils'

type ChangeFieldWithoutDiffProps = {
  change: ChangeRecord
  action: ChangeHistoryAction
}

export function ChangeFieldWithoutDiff({
  change,
  action,
}: ChangeFieldWithoutDiffProps) {
  const { before, after } = prepareValues(change, action)

  return (
    <div className="grid grid-cols-2 gap-4">
      <div>
        <p className="text-body text-gray-500 mb-1">Before</p>
        <pre className="text-body bg-gray-50 p-2 rounded border overflow-x-auto whitespace-pre-wrap break-words">
          {before}
        </pre>
      </div>
      <div>
        <p className="text-body text-gray-500 mb-1">After</p>
        <pre className="text-body bg-gray-50 p-2 rounded border overflow-x-auto whitespace-pre-wrap break-words">
          {after}
        </pre>
      </div>
    </div>
  )
}
